<template>
  <qx-card-form title="证照信息" v-show="showComponent" :defaultContentShow="false">
    <span slot="titleLeft" class="notices error" v-if="isAddDrivingLicenseDateShow" style="margin-left: 10px">注意：行驶证证照信息和行驶证失效日期，需在车辆年审内维护</span>
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>

<script>
import {
  checkVehicleNumber,
  getBigImg,
} from '@qx/utils/index';
import {
  getVehicleLicense,
  getTenantTrailerRelByPlateNumber,
} from 'api/car';
import {
  getFileUrl,
} from 'api';
import { attachmentFiles, refreshUploadFiles } from '../attachmentFiles';
export default {
  data () {
    return {
      showComponent: true,
      // 是否显示【行驶证注册时间】数据维护提示
      isAddDrivingLicenseDateShow: false,
      otherFormData: {
      },
      baseForm: {
        // 品牌名称
        vehicleBrandOptions: [],
        inline: true,
        form: [
          {
            label: '行驶证正本',
            value: 'drivingLicense',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            attr: {
              limit: 1,
            },
            default: [],
            onChange: async (arr) => {
              // 获取原图（原图才能识别，缩略图识别不了）
              const drivingLicenseInfo = await getVehicleLicense({ url: getBigImg(arr[0].url) });
              const formData = await this.$refs.baseForm.getVal();
              if (drivingLicenseInfo.trailerNumber) {
                formData.trailerNumber = drivingLicenseInfo.trailerNumber;
              }
              if (drivingLicenseInfo.registrationDate) {
                formData.drivingLicenseDate = drivingLicenseInfo.registrationDate;
              }
              this.drivingLicenseInfo = drivingLicenseInfo;
              this.checkVehiclePlateNumberCanRegister(drivingLicenseInfo.trailerNumber);
            },
          },
          {
            label: '行驶证副本',
            value: 'adriverLicenseCopy',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            attr: {
              limit: 1,
            },
            default: [],
          },
          {
            label: '行驶证注册日期',
            value: 'drivingLicenseDate',
            type: 'date',
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '行驶证失效日期',
            value: 'vehicleValidityExpiredTime',
            type: 'date',
            attr: {
              time: '00:00:00',
            },
          },
        ],
        rules: {
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    // 检测车牌号码格式以及是否已在此车队注册
    async checkVehiclePlateNumberCanRegister (trailerNumber) {
      if (checkVehicleNumber(trailerNumber)) {
        await getTenantTrailerRelByPlateNumber({ trailerNumber });
      }
    },
    async handleSubData (cache) {
      let formData = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData.drivingLicense = await refreshUploadFiles(formData.drivingLicense || []);
        formData.adriverLicenseCopy = await refreshUploadFiles(formData.adriverLicenseCopy || []);
        if (formData.drivingLicense && formData.drivingLicense.length) {
          // 如果有上传图片，则提交或者缓存的时候设置 drivingLicenseId 和 图片 url 字段
          formData.drivingLicenseId = formData.drivingLicense[0].id;
          formData.drivingLicenseUrl = formData.drivingLicense[0].url;
        } else {
          // 如果没有图片，设置一个空字段提交
          formData.drivingLicenseUrl = '';
        }
        if (formData.adriverLicenseCopy && formData.adriverLicenseCopy.length) {
          formData.adriverLicenseCopyId = formData.adriverLicenseCopy[0].id;
          formData.adriverLicenseCopyUrl = formData.adriverLicenseCopy[0].url;
        } else {
          formData.adriverLicenseCopyId = '';
          formData.adriverLicenseCopyUrl = '';
        }
        formData.vehicleValidityExpiredTime = formData.vehicleValidityExpiredTime ? this.formatDate(formData.vehicleValidityExpiredTime) : '';
        formData.drivingLicenseDate = formData.drivingLicenseDate ? this.formatDate(formData.drivingLicenseDate) : '';
      }
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    async sub () {
      let formData = await this.handleSubData();
      if (formData) {
        // 删除两个不必要的参数
        delete formData.drivingLicense;
        delete formData.adriverLicenseCopy;
      }
      console.log('证照信息提交参数', formData);
      return formData;
    },
    async setDetailData (data) {
      let flowIds = [];

      if (data.trailer) {
        // 如果是详情返回的
        data.trailerNumber = data.trailer.trailerNumber;
        data.vehicleValidityTime = data.trailer.vehicleValidityTime;
        data.vehicleValidityExpiredTime = data.trailer.vehicleValidityExpiredTime;
        data.drivingLicenseDate = data.trailer.drivingLicenseDate;
        data.drivingLicenseId = data.trailer.drivingLicenseId;
        data.drivingLicenseUrl = data.trailer.drivingLicenseUrl;
        data.adriverLicenseCopyId = data.trailer.adriverLicenseCopyId;
        data.adriverLicenseCopyUrl = data.trailer.adriverLicenseCopyUrl;
      }

      if (data.drivingLicenseId) {
        flowIds.push(data.drivingLicenseId);
      }
      if (data.adriverLicenseCopyId) {
        flowIds.push(data.adriverLicenseCopyId);
      }

      const urlRes = flowIds.length ? await getFileUrl({
        flowIds: flowIds.join(','),
        _GRID_TYPE: 'jq',
      }) : [];

      const findImgPath = (flowId) => (attachmentFiles(flowId, urlRes)[0] || {}).url || '';

      if (data.drivingLicenseId) {
        // 如果有详情或者操作缓存返回id，也就是代表有图片，则要设置
        data.drivingLicense = [{
          id: data.drivingLicenseId,
          url: findImgPath(data.drivingLicenseId),
        }];
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'disabled',
          value: true,
          names: ['drivingLicense'],
        });
      } else {
        data.drivingLicense = [];
      }
      if (data.adriverLicenseCopyId) {
        data.adriverLicenseCopy = [{
          id: data.adriverLicenseCopyId,
          url: findImgPath(data.adriverLicenseCopyId),
        }];
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'disabled',
          value: true,
          names: ['adriverLicenseCopy'],
        });
      } else {
        data.adriverLicenseCopy = [];
      }
    },
    // 设置所有表单
    async resetBaseForm (data) {
      if (data.vehicleValidityExpiredTime) {
        this.isAddDrivingLicenseDateShow = true;
      } else {
        this.isAddDrivingLicenseDateShow = false;
      }
      // 隐藏除了【基础信息】和【车辆参数】之外的其他模块
      await this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: Boolean(data.vehicleValidityExpiredTime),
        names: ['vehicleValidityExpiredTime'],
      });
    },
    async init (data = {}) {
      this.$refs.baseForm.reset();
      await this.setDetailData(data);
      await this.resetBaseForm(data);
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style lang="sass" scoped></style>
